import { checkIsMobile } from '@/utils/dom';

export const throttle = (cb, delay = 500) => {
  let wait = false;
  let waitingArgs = null;

  const delayFunc = () => {
    if (waitingArgs === null) {
      wait = false;
    } else {
      cb(...waitingArgs);
      waitingArgs = null;
      setTimeout(delayFunc, delay);
    }
  };

  return (...args) => {
    if (wait) {
      waitingArgs = args;
      return;
    }

    cb(...args);
    wait = true;
    waitingArgs = args;

    setTimeout(delayFunc, delay);
  };
};

export const debounce = (cb, delay = 300) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cb(...args);
    }, delay);
  };
};

export const waitObjectProperty = (prop, parent = window, timeout = 5_000) =>
  new Promise((resolve, reject) => {
    const delay = 50;
    let retries = 0;

    const start = Date.now();
    const check = () => {
      if (parent.hasOwnProperty(prop)) {
        return resolve(parent[prop]);
      }
      if (Date.now() > start + timeout) {
        return reject(`Cannot find property ${prop} of ${parent}`);
      }
      setTimeout(check, delay * ++retries);
    };
    check();
  });

export const checkWindowSize = debounce(() => {
  document.dispatchEvent(
    new CustomEvent('resize::update', {
      detail: {
        isMobile: checkIsMobile(),
      },
    })
  );
}, 200);
